import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      if (localStorage.getItem("mc_install_dismissed") === "1") return;
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setShow(false);
  };
  const dismiss = () => { localStorage.setItem("mc_install_dismissed", "1"); setShow(false); };

  if (!show) return null;
  return (
    <div data-testid="install-prompt" className="fixed bottom-20 inset-x-0 z-40 px-4">
      <div className="mx-auto max-w-2xl rounded-2xl p-4 flex items-center gap-3 text-white shadow-[0_8px_32px_rgba(44,44,62,0.25)]" style={{ background: "linear-gradient(135deg,var(--brand-navy),var(--brand-navy-dark))" }}>
        <div className="h-10 w-10 rounded-xl bg-white/15 flex items-center justify-center shrink-0"><Download className="h-5 w-5" /></div>
        <div className="flex-1 min-w-0">
          <div className="font-heading font-bold text-sm leading-tight">Install MissionCompanion</div>
          <div className="text-xs text-white/70">Add to your home screen for quick access — works offline too.</div>
        </div>
        <button data-testid="install-accept-btn" onClick={install} className="shrink-0 rounded-full bg-white text-[var(--brand-navy)] font-semibold text-sm px-4 py-2 hover:opacity-90 transition-opacity">Install</button>
        <button data-testid="install-dismiss-btn" onClick={dismiss} className="shrink-0 h-8 w-8 rounded-full flex items-center justify-center hover:bg-white/10"><X className="h-4 w-4" /></button>
      </div>
    </div>
  );
};

export default InstallPrompt;
